import React from "react";
import styles from "./Home.module.css";
import myImage2 from "../../Assets/myimage2.png";
import Fade from "react-reveal/Fade";
import Typewriter from "typewriter-effect";

const Home = () => {
  return (
    <div className={styles.mainHomeDiv}>
      <div className={styles.homeDiv}>
        <Fade duration={3000}>
          <img className={styles.homeDivImg2} alt="mypic" src={myImage2} />
        </Fade>
        <div className={styles.homeDivText}>
          <Fade top duration={2000}>
            <h1 style={{ fontSize: "50px" }}>Hello World.</h1>
          </Fade>
          <Fade top duration={2000}>
            <h3 style={{ fontSize: "30px" }}>I'm Aniket Yadav</h3>
          </Fade>
          <Fade top duration={2000}>
            <div className={styles.typerText}>
              <p style={{ fontWeight: "bold" }}>I love to</p>
              &nbsp;
              <Typewriter
                style={{ fontWeight: "bold" }}
                options={{
                  autoStart: true,
                  loop: true,
                  delay: 40,
                  strings: [
                    "Code.",
                    "Develop new stuffs.",
                    "Solve Problems.",
                    "Talk about tech.",
                    "Visit places.",
                  ],
                }}
              />
            </div>
          </Fade>
        </div>
      </div>
    </div>
  );
};

export default Home;
